import { CoreIcon } from '../core-icon';
import bankApplepaySVG from '../../assets/logos/bank-applepay.svg';
import type { IconProps } from '../core-icon';

export const BankApplepayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankApplepaySVG} {...props} />;
};
